import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { InfiniteResult } from '../_models/body';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class VoiceService {

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<InfiniteResult>(`${environment.apiEndpoint}api/VoiceClone/Query`, {
      params: {
        pageSize: -1
      }
    });
  }

  addVoice(data: any) {
    const formParams = new FormData();
    formParams.append('SpeakerName', data.speakerName);
    formParams.append('LangCode', data.langCode);
    (data.files || []).forEach((item: File | { file: File }) => {
      const file = item instanceof File ? item : item?.file;
      if (file) {
        formParams.append('Files', file, file.name);
      }
    });
    return this.http.post<any>(`${environment.apiEndpoint}api/VoiceClone`, formParams);
  }

  deleteVoice(id: string) {
    return this.http.delete<any>(`${environment.apiEndpoint}api/VoiceClone/${id}`)
  }
}
